import { useState } from 'react';
import { MAX_APPLICANTS_TO_DISPLAY } from 'src/shared/constants';
export var useCasesGlobalViewPage = function (props) {
    var information = props.information, documentWidgetTab = props.documentWidgetTab, updateCurrentApplicants = props.updateCurrentApplicants, applicants = props.applicants;
    var _a = useState(0), informationTabIndex = _a[0], setInformationTabIndex = _a[1];
    var _b = useState(0), contentTabIndex = _b[0], setContentTabIndex = _b[1];
    var isTabCompressed = applicants.length > MAX_APPLICANTS_TO_DISPLAY;
    var handleInformationTabChange = function (newIndex) {
        setInformationTabIndex(newIndex);
        var currentTab = information.tabs[newIndex];
        var applicantId = currentTab === null || currentTab === void 0 ? void 0 : currentTab.applicantId;
        if (applicantId && !isTabCompressed) {
            updateCurrentApplicants(applicantId);
            var documentTabCorrespondingIndex = documentWidgetTab.findIndex(function (tab) { return tab.applicantId === applicantId; });
            if (documentTabCorrespondingIndex !== -1) {
                setContentTabIndex(documentTabCorrespondingIndex);
            }
        }
    };
    var handleDocumentsTabChange = function (newIndex) {
        setContentTabIndex(newIndex);
        var currentTab = documentWidgetTab[newIndex];
        var applicantId = currentTab === null || currentTab === void 0 ? void 0 : currentTab.applicantId;
        if (applicantId && !isTabCompressed) {
            updateCurrentApplicants(applicantId);
            var informationTabCorrespondingIndex = information.tabs.findIndex(function (tab) { return tab.applicantId === applicantId; });
            if (informationTabCorrespondingIndex !== -1) {
                setInformationTabIndex(informationTabCorrespondingIndex);
            }
        }
    };
    return {
        informationTabIndex: informationTabIndex,
        contentTabIndex: contentTabIndex,
        handleInformationTabChange: handleInformationTabChange,
        handleDocumentsTabChange: handleDocumentsTabChange,
    };
};
